export function setActions(actions) {
  return {
    type: 'setActions',
    payload: actions
  }
}

export function setBadges(payload) {
  return {
    type: 'setBadges',
    payload: payload
  }
}

export function setCanUseAPI(payload) {
  return {
    type: 'setCanUseAPI',
    payload: payload
  }
}

export function setChannels(payload) {
  return {
    type: 'setChannels',
    payload: payload
  }
}

export function setColor(payload) {
  return {
    type: 'setColor',
    payload: payload
  }
}

export function setOffsetX(payload) {
  return {
    type: 'setOffsetX',
    payload: payload
  }
}

export function setOffsetY(payload) {
  return {
    type: 'setOffsetY',
    payload: payload
  }
}

export function setPosition(payload) {
  return {
    type: 'setPosition',
    payload: payload
  }
}

export function setLogo(payload) {
  return {
    type: 'setLogo',
    payload: payload
  }
}

export function setItemsVisibility(payload) {
  return {
    type: 'openChannels',
    payload: payload
  }
}

export function setFlashcard(payload) {
  return {
    type: 'setFlashcard',
    payload: payload
  }
}

export function setHideAllBtn(payload) {
  return {
    type: 'setHideAllBtn',
    payload: payload
  }
}

export function setIsFrameOpened(payload) {
  return {
    type: 'setIsFrameOpened',
    payload: payload
  }
}

export function setIsLoaderHidden(payload) {
  return {
    type: 'setIsLoaderHidden',
    payload: payload
  }
}

export function setLanguage(payload) {
  return {
    type: 'setLanguage',
    payload: payload
  }
}

export function setMediaMobileWidth(payload) {
  return {
    type: 'setMediaMobileWidth',
    payload: payload
  }
}

export function setWidgetVersion(payload) {
  return {
    type: 'setWidgetVersion',
    payload: payload
  }
}

export function setStyleTemplate(payload) {
  return {
    type: 'setStyleTemplate',
    payload: payload
  }
}

export function setTranslations(payload) {
  return {
    type: 'setTranslations',
    payload: payload
  }
}

// todo implement in widget
export function setGeneralData(payload) {
  return {
    type: 'setGeneralData',
    payload: payload
  }
}
